module.exports = __webpack_public_path__ + "media/images/lb/355-6a2b7b634b3c5d9ed252f6f343c9a14e.svg";